import TagManager from "react-gtm-module";

export const initialize = () => {
  TagManager.initialize({ gtmId: window.ENVIRONMENT.__HOOPLA_GTM__ });
};

export default TagManager;
